import ComponentPasteLogic from './ComponentPasteLogic';
import AddPanelPasteLogic from './AddPanelPasteLogic';

const pasteContext = new ComponentPasteLogic();
const duplicateContext = new ComponentPasteLogic();
const addContext = new ComponentPasteLogic({ centerOnFirstPaste: true });
const addPanelPasteLogic = new AddPanelPasteLogic();

export { pasteContext, duplicateContext, addContext, addPanelPasteLogic };
